import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HC_more from 'highcharts/highcharts-more'
import Guage from 'highcharts/modules/solid-gauge';

HC_more(Highcharts);

Guage(Highcharts);

const GaugeChart = (props) => {

  const options = {
    chart: {
      type: 'gauge',
      plotBackgroundColor: null,
      plotBackgroundImage: null,
      plotBorderWidth: 0,
      plotShadow: false,
      height: '80%',
    },
    title: {
      text: props.chartTitle,
      style: {
        fontSize: '20px',
        fontWeight: '600',
      },
    },
    exporting: {
      enabled: false,
    },
    pane: {
      startAngle: -90,
      endAngle: 89.9,
      background: null,
      center: ['50%', '75%'],
      size: '110%'
    },
    yAxis: {
      min: 0,
      max: props.maxValue,
      tickPixelInterval: 40,
      tickPosition: 'inside',
      tickColor: Highcharts.defaultOptions.chart.backgroundColor || '#FFFFFF',
      tickLength: 20,
      tickWidth: 2,
      minorTickInterval: null,
      labels: {
        distance: 20,
        style: {
          fontSize: '14px'
        }
      },
      plotBands: [{
        from: 0,
        to: props.maxValue,
        color: '#55BF3B',
        thickness: 20
      }]
    },
    series: [{
      name: props.chartTitle,
      data: props.seriesData,
      tooltip: {
        valueSuffix: ' ' + props.seriesValueSuffix,
      },
      dataLabels: {
        format: '{y} ' + props.seriesValueSuffix,
        borderWidth: 0,
        color: (
          Highcharts.defaultOptions.title && 
          Highcharts.defaultOptions.title.style &&
          Highcharts.defaultOptions.title.style.color
        ) || '#333333',
        style: {
          fontSize: '18px',
          fontWeight: '600',
        }
      },
      dial: {
        radius: '80%',
        backgroundColor: 'gray',
        baseWidth: 12,
        baseLength: '0%',
        rearLength: '0%',
      },
      pivot: {
        backgroundColor: 'gray',
        radius: 6,
      },
    }],
  };

  return (    
    <HighchartsReact highcharts={Highcharts} options={options} />
  );
}

export default GaugeChart;
